import axios from 'axios'
import KeycloakService from '../utils/keycloakService'
import {
  getAllLabDepartmentsEndpoint,
  getLabOrders,
  RADIOLOGY_ORDERS_OPD_LOCATION,
  UpdateLablocation,
  updateOrderEvent,
} from '../features/bedManagement/endpoints/EndPoints'
import { getPhase } from '../features/lms/utils'
import {
  ADMIN_PROJECT_ID,
  archiveLab,
  archivelabOrdersByPatient,
  backlogCategory,
  CREATE_TESTCODES_ENDPOINT,
  currentCategory,
  deleteLab,
  ENABLED,
  errorcluster,
  FILE_UPLOAD_ENDPOINT,
  GET_ALL_DEVICE_MODELS_ENDPOINT,
  GET_ALL_PARAMETERS_ENDPOINT,
  GET_TESTCODES_BY_DEVICE_ID_ENDPOINT,
  getClusterandType,
  LAB_DEVICE_ENDPOINT,
  labOrganizations,
  LABS_PROJECT_ID,
  OPD_PROJECT_ID,
  PACKAGE_PROJECT_ID,
  RADIOLOGY_PROJECT_ID,
  successcluster,
  UPLOAD,
  vendorCustomers,
} from '../utils/constants'
import { toast } from 'react-toastify'
import { startSxpProxy } from '../utils/api'
import { lmsIntent } from './constants'
import { Labintent, locErrorMsg } from '../features/lms/constants'
import { optionValue } from '../features/labTests/models'
import { dropDownMenuKeys, intent } from '../components/constants'
import { OPD_ORDERS_CONSTANTS } from '../features/labTests/opdOrdersConstants'
import HttpService from '../utils/httpService'
import { intentLab } from '../features/lms/models'

const axiosClient = HttpService.getAxiosClient()

export const fetchActiveBacklogOrders = async (
  selectedDate: string,
  source: string,
  activeTab: string,
  active: boolean,
  page?: number,
  pageSize?: number
) => {
  const offset = page ? page * (pageSize || 100) : 0
  const limit = pageSize || 100
  const start = `${selectedDate}T00:00:00`
  const nextDay = new Date(selectedDate)
  nextDay?.setDate(nextDay?.getDate() + 1)
  const end = `${nextDay?.toISOString()?.split('T')[0]}T00:00:00`

  try {
    const state = {
      limit: limit,
      offset: offset,
      source: `${source}`,
      activeTab: getPhase(activeTab),
      start: start,
      end: end,
      active: active,
      category: backlogCategory,
    }
    const response = await startSxpProxy(
      LABS_PROJECT_ID,
      lmsIntent?.fetchLabOrders,
      state
    )
    return {
      data: response?.data,
      success: true,
    }
  } catch {
    return {
      data: null,
      success: false,
    }
  }
}
export const activeFetchBacklogOrders = async (
  source: any,
  activeTab: any,
  selectedDate: string,
  active: boolean,
  page?: number,
  pageSize?: number
) => {
  const offset = page ? page * (pageSize || 100) : 0
  const limit = pageSize || 100
  const nextDate = new Date(selectedDate)
  nextDate?.setDate(nextDate?.getDate() + 1)
  const nextDateString = nextDate?.toISOString()?.split('T')[0]

  try {
    const state = {
      limit: limit,
      offset: offset,
      source: `${source}`,
      activeTab: getPhase(activeTab),
      start: selectedDate,
      end: nextDateString,
      active: active,
      category: currentCategory,
    }
    const response = await startSxpProxy(
      LABS_PROJECT_ID,
      lmsIntent?.fetchLabOrders,
      state
    )

    return {
      data: response?.data,
      success: true,
    }
  } catch {
    return {
      data: null,
      success: false,
    }
  }
}

export const getAllLabDevices = async (
  offset: number,
  pageSize: number,
  param: string,
  value: string
) => {
  const token = KeycloakService?.getToken()
  try {
    const response: any = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${LAB_DEVICE_ENDPOINT}?offset=${offset}&limit=${pageSize}&${param}=${value}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    if (response?.data?.success) {
      const { data, message, success } = response?.data ?? {}
      return {
        data,
        message,
        success,
      }
    } else {
      return {
        success: false,
        data: [],
        message: response?.data?.message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}

export const createDevice = async (values: any) => {
  const token = KeycloakService?.getToken()
  try {
    delete values?.id
    const response = await axios.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${LAB_DEVICE_ENDPOINT}`,
      values,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.success) {
      const { data, message, success } = response?.data ?? {}
      return {
        data,
        message,
        success,
      }
    } else {
      return {
        success: false,
        data: [],
        message: response?.data?.message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}

export const updateDeviceById = async (values: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_API_GATEWAY_URL}${LAB_DEVICE_ENDPOINT}/${values?.id}`,
      values,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.success) {
      const { data, message, success } = response?.data ?? {}
      return {
        data,
        message,
        success,
      }
    } else {
      return {
        success: false,
        data: [],
        message: response?.data?.message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}

export const getDeviceById = async (selectedLMSItemId: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${LAB_DEVICE_ENDPOINT}/${selectedLMSItemId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.success) {
      const { data, message, success } = response?.data ?? {}
      return {
        data,
        message,
        success,
      }
    } else {
      return {
        success: false,
        data: [],
        message: response?.data?.message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}

export const deletedevice = async (data: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_API_GATEWAY_URL}${LAB_DEVICE_ENDPOINT}/${data?.id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.success) {
      const { data, message, success } = response?.data ?? {}
      return {
        data,
        message,
        success,
      }
    } else {
      return {
        success: false,
        data: [],
        message: response?.data?.message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}

export const toggleEnable = async (data: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_API_GATEWAY_URL}${LAB_DEVICE_ENDPOINT}/${data?.id}/${ENABLED}`,
      { enabled: !data?.enabled },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.success) {
      const { data, message, success } = response?.data ?? {}
      return {
        data,
        message,
        success,
      }
    } else {
      return {
        success: false,
        data: [],
        message: response?.data?.message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}

export const addParameterMapping = async (data: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${CREATE_TESTCODES_ENDPOINT}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.success) {
      const { data, message, success } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    } else {
      return {
        success: false,
        data: [],
        message: response?.data?.message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}

export const getTestCodesByModelId = async (
  data: any,
  offset: number,
  pageSize: number
) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${GET_TESTCODES_BY_DEVICE_ID_ENDPOINT}${data}?offset=${offset}&limit=${pageSize}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.success) {
      const { data, success, message } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    } else {
      return {
        success: false,
        data: [],
        message: response?.data?.message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}

export const getTestCodesById = async (data: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${CREATE_TESTCODES_ENDPOINT}/${data}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.success) {
      const { data, success, message } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    } else {
      return {
        success: false,
        message: response?.data?.message,
        data: [],
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}

export const updateTestCode = async (data: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_API_GATEWAY_URL}${CREATE_TESTCODES_ENDPOINT}/${data?.id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.success) {
      const { data, message, success } = response?.data ?? {}
      return {
        data,
        message,
        success,
      }
    } else {
      return {
        data: [],
        success: false,
        message: response?.data?.message,
      }
    }
  } catch (error: any) {
    return {
      data: [],
      success: false,
      message: error?.response?.data?.message,
    }
  }
}

export const uploadTestCodeFile = async (data: any, id: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${FILE_UPLOAD_ENDPOINT}${id}${UPLOAD}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.success) {
      const { data, message, success } = response?.data ?? {}
      return {
        data,
        message,
        success,
      }
    } else {
      return {
        success: false,
        data: [],
        message: response?.data?.message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}

export const deleteTestCode = async (data: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_API_GATEWAY_URL}${CREATE_TESTCODES_ENDPOINT}/${data?.id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.success) {
      const { data, message, success } = response?.data ?? {}
      return {
        data,
        message,
        success,
      }
    } else {
      return {
        success: false,
        data: [],
        message: response?.data?.message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}

export const getAllLabDepartments = async () => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${getAllLabDepartmentsEndpoint}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    return {
      success: true,
      data: response?.data,
      message: 'Fetched Lab Departments',
    }
  } catch (error: any) {
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}

export const getAllLabDeviceModels = async (
  offset: number,
  pageSize: number
) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${GET_ALL_DEVICE_MODELS_ENDPOINT}?offset=${offset}&limit=${pageSize}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    if (response?.data?.success) {
      const { data, success, message } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    } else {
      return {
        success: false,
        data: [],
        message: response?.data?.message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}

export const getDeviceModelById = async (Id: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${GET_ALL_DEVICE_MODELS_ENDPOINT}/${Id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.success) {
      const { data, message, success } = response?.data ?? {}
      return {
        data,
        message,
        success,
      }
    } else {
      return {
        success: false,
        message: response?.data?.message,
        data: [],
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}

export const createDeviceModel = async (values: any) => {
  const token = KeycloakService?.getToken()
  try {
    delete values?.id
    const response = await axios.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${GET_ALL_DEVICE_MODELS_ENDPOINT}`,
      values,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.success) {
      const { data, message, success } = response?.data ?? {}
      return {
        data,
        message,
        success,
      }
    } else {
      return {
        success: false,
        data: [],
        message: response?.data?.message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}

export const updateDeviceModelById = async (values: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_API_GATEWAY_URL}${GET_ALL_DEVICE_MODELS_ENDPOINT}/${values?.id}`,
      values,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.success) {
      const { data, success, message } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    } else {
      return {
        success: false,
        data: [],
        message: response?.data?.message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}

export const deleteDeviceModel = async (data: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_API_GATEWAY_URL}${GET_ALL_DEVICE_MODELS_ENDPOINT}/${data?.id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.success) {
      const { data, message, success } = response?.data ?? {}
      return {
        data,
        message,
        success,
      }
    } else {
      return {
        success: false,
        data: [],
        message: response?.data?.message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}

export const healthScoreAPI = async (data: any) => {
  const token = KeycloakService?.getToken()
  const response = await axios.post(
    `${process.env.REACT_APP_API_GATEWAY_URL}api/healthindex-score/compute`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    }
  )
  return response?.data
}

export const getAllParameters = async () => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${GET_ALL_PARAMETERS_ENDPOINT}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.lab_test) {
      return {
        success: true,
        data: response?.data,
      }
    } else {
      return {
        success: false,
        data: [],
        message: 'Error while fetching THOP parameters',
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: [],
      message: 'Error while fetching THOP parameters',
    }
  }
}

export const enableDeviceModel = async (data: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_API_GATEWAY_URL}${GET_ALL_DEVICE_MODELS_ENDPOINT}/${data?.id}/${ENABLED}`,
      {
        enabled: !data?.enabled,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.success) {
      const { data, success, message } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    } else {
      const { data, success, message } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}
export const UpdateLabInvoice = async (
  origin: any,
  products: any,
  documentId: number,
  orderRef: any
) => {
  const state = {
    origin,
    payload: {
      ...(origin !== 'B2B' && { document_type: 'invoice' }),
      ...(origin == 'B2B'
        ? { order_id: documentId }
        : { document_id: documentId }),
      products_list: products,
      order_ref: orderRef,
    },
  }

  try {
    const response = await startSxpProxy(
      LABS_PROJECT_ID,
      lmsIntent?.updateLabOrderInvoice,
      state
    )
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const CreateLabInvoice = async (
  selectedLocationId: any,
  origin: string,
  products: any,
  patientIdentifier: any,
  reqOdooId: string,
  reqDoctorRef: string,
  mode: any,
  radiology?: boolean
) => {
  const state = {
    selectedLocationId,
    origin,
    products,
    patient_identifier: patientIdentifier,
    reqOdooId: reqOdooId,
    doctor_thop_id: reqDoctorRef,
    mode: mode,
    radiology: radiology || false,
  }
  try {
    const response = await startSxpProxy(
      LABS_PROJECT_ID,
      lmsIntent?.createLabInvoice,
      state
    )
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}
export const getAllPanelsApi = async (): Promise<any[]> => {
  try {
    const state = {}
    const data = await startSxpProxy(
      LABS_PROJECT_ID,
      lmsIntent?.getAllPanelsApi,
      state
    )
    const panelData: any[] = data?.data?.panel ?? []
    const tests = panelData.map((test: any) => ({
      label: test?.name,
      value: String(test?.id),
      panel: {
        name: test?.name,
        description: test?.description,
        id: test?.id,
        lab_tests: test?.lab_tests,
        sampleId: parseInt(test?.sample?.value),
        sampleName: test?.sample?.name,
      },
    }))
    return tests
  } catch (error) {
    console.error(error)
    return []
  }
}
export const getAllRadiologyTestsApi = async (): Promise<any[]> => {
  try {
    const state = {}
    const data = await startSxpProxy(
      RADIOLOGY_PROJECT_ID,
      OPD_ORDERS_CONSTANTS.INTENT_GET_RADIOLOGY_TESTS,
      state
    )
    const panelData = data?.data?.radiology_lab_test ?? []
    const tests = panelData?.map((test: any) => ({
      label: test?.name,
      value: test?.id,
      sampleId: test?.sample_id,
      sampleName: test?.radiology_sample?.name,
      odoo_test_id: test?.odoo_test_id,
    }))
    return tests
  } catch (error) {
    console.error(error)
    return []
  }
}

export const getLabInvoices = async (
  state = {
    ref_prefix: 'LAB',
    doc_type: 'invoice',
  }
) => {
  try {
    const response = await startSxpProxy(
      LABS_PROJECT_ID,
      lmsIntent?.getOrderInvoices,
      state
    )
    return response
  } catch (error) {
    console.error('Error fetching lab invoices:', error)
    throw error
  }
}

export const createdOrderEvent = async (state: any) => {
  try {
    const response = await startSxpProxy(
      LABS_PROJECT_ID,
      lmsIntent?.createOrderEvent,
      state
    )
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const getOdooProductPrice = async (state: any) => {
  try {
    const response = await startSxpProxy(
      LABS_PROJECT_ID,
      lmsIntent?.getTestPriceFromOdoo,
      state
    )
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const updateLabOrderPU = async (payload: any) => {
  const token = KeycloakService?.getToken()

  try {
    const data = await axios.put(
      `${process.env.REACT_APP_API_GATEWAY_URL}${UpdateLablocation}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    return {
      data: data.data,
      success: true,
      message: locErrorMsg?.AsignedLoc,
    }
  } catch (error: any) {
    const message =
      error?.response?.data?.message || error.message || 'Update failed'
    toast.error(message)

    return {
      data: null,
      success: false,
      message,
    }
  }
}
export const cancelLabOrder = async (origin: any, labOrderId: any) => {
  const state = {
    origin,
    labOrderId,
  }
  try {
    const response = await startSxpProxy(
      LABS_PROJECT_ID,
      lmsIntent?.CancelLabOrder,
      state
    )
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}
export const getOrganizationForVendor = async () => {
  try {
    const token = KeycloakService?.getToken()
    const response = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${vendorCustomers}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}
export const PackageInvoice = async (
  selectedLocationId: any,
  odooProductId: any,
  products: any,
  patientIdentifier: number,
  productName: string
) => {
  const state = {
    selectedLocationId,
    odooProductId,
    identifier: patientIdentifier,
    companyJournalId: 17,
    companyOdooId: 1,
    productName,
  }
  try {
    const response = await startSxpProxy(
      PACKAGE_PROJECT_ID,
      lmsIntent?.buyPackage,
      state
    )
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const updatedOrderEvent = async (state: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios?.put(
      `${process.env.REACT_APP_API_GATEWAY_URL}${updateOrderEvent}`,
      state,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    return {
      data: response?.data,
      success: true,
    }
  } catch {
    return {
      data: null,
      success: false,
    }
  }
}

export const updateOrderPhases = async (orderId: any, phases: any) => {
  try {
    const state = {
      id: orderId,
      active_phases: phases,
      updated_on: new Date().toISOString(),
    }
    const response = await startSxpProxy(
      LABS_PROJECT_ID,
      lmsIntent?.updateLabOrderPhase,
      state
    )
    return {
      data: response?.data,
      success: true,
    }
  } catch {
    return {
      data: null,
      success: false,
    }
  }
}
export const getPatientDataByTypeAndUhidForOrders = async (
  type: string,
  uhid: string
) => {
  try {
    const url =
      type === optionValue?.LAB?.value
        ? `${process.env.REACT_APP_ODOO_URL}/references?ref_prefix=${type}&partner_ref=${uhid}`
        : `${process.env.REACT_APP_ODOO_URL}/api/sale_orders?partner_ref=${uhid}&limit=10&ref_prefix=${type}`

    const response: any = await axios.get(url, {
      headers: {
        'api-key': process.env.REACT_APP_ODOO_API_KEY || '',
      },
    })
    if (response?.data) {
      return {
        success: true,
        data: response?.data,
        message: 'Data Fetched Successfully',
      }
    } else {
      return {
        success: false,
        data: null,
        message: 'Failed to Fetch Data',
      }
    }
  } catch (error: any) {
    console.error('Error: ', error)
    return {
      success: false,
      data: null,
      message: error?.message,
    }
  }
}
export const deleteLabOrder = async (data: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_API_GATEWAY_URL}${deleteLab}${data}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.success) {
      const { data, success, message } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    } else {
      const { data, success, message } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    }
  } catch (error: any) {
    console.log(error?.response?.data?.message)
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}
export const archiveLabOrder = async (data: any, lmsTabStatus: string) => {
  const token = KeycloakService?.getToken()
  const tab =
    lmsTabStatus === dropDownMenuKeys?.active
      ? dropDownMenuKeys?.inActive
      : dropDownMenuKeys?.active
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_API_GATEWAY_URL}${archiveLab}${data}/${tab}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.success) {
      const { data, success, message } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    } else {
      const { data, success, message } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    }
  } catch (error: any) {
    console.log(error?.response?.data?.message)
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}
export const archivalLabOrders = async (
  patientId: any,
  pageSize: any,
  page: any
) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${archivelabOrdersByPatient}`,
      {
        patientId: patientId,
        limit: pageSize,
        offset: page,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    console.log(response, 'asdsadas')
    if (response?.data?.lab_orders_archive?.length > 0) {
      const { data, success, message } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    } else {
      const { data, success, message } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    }
  } catch (error: any) {
    console.log(error?.response?.data?.message)
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}
export const getLabOrdersByPatient = async (
  searchParam: any,
  activeTab: string | undefined,
  locationId: any,
  pageSize: number,
  page: number,
  lmsStatusTab: string
) => {
  try {
    const token = KeycloakService?.getToken()
    const active = lmsStatusTab === dropDownMenuKeys?.active ? true : false
    const response = await axios.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${getLabOrders}`,
      {
        limit: pageSize,
        offset: pageSize * page,
        filter: {
          operating_unit: { _like: `%${locationId}%` },
          active_phases: { _contains: getPhase(activeTab) },
          patient_id: { _in: searchParam },
          active: { _eq: active },
        },
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.lab_orders?.length > 0) {
      return {
        success: true,
        data: response?.data,
        message: 'Fetched Lab Orders Successfully',
      }
    } else {
      return {
        success: true,
        data: [],
        message: 'No Data Found',
      }
    }
  } catch {
    return {
      success: false,
      data: [],
      message: 'Error Occured',
    }
  }
}
export const getLabOrganizations = async () => {
  try {
    const token = KeycloakService?.getToken()
    const response = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${labOrganizations}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    if (response?.data?.organization?.length > 0) {
      return {
        success: true,
        data: response?.data,
        message: 'Fetched Lab Organizations Successfully',
      }
    } else {
      return {
        success: false,
        data: [],
        message: 'No Data Found',
      }
    }
  } catch {
    return {
      success: false,
      data: [],
      message: 'Error Occured',
    }
  }
}
export const generateGlobalId = async () => {
  const CHAT_PROJECT_ID = process.env.REACT_APP_CHAT_PROJECT_ID || ''
  const intent = 'generateGlobalId'
  const state = {}
  try {
    const response = await startSxpProxy(CHAT_PROJECT_ID, intent, state)
    return {
      response: response?.data,
      success: true,
      message: 'Global ID generated successfully',
    }
  } catch (error) {
    return {
      response: null,
      success: false,
      message: 'Error generating Global ID',
    }
  }
}
export const searchLabOrders = async (param: string, value: string) => {
  try {
    const response = await startSxpProxy(LABS_PROJECT_ID, 'labOrdersSearch', {
      param,
      value,
    })
    return {
      response: response?.data,
      success: true,
      message: 'Retrived Lab Orders',
    }
  } catch (error) {
    return {
      response: null,
      success: false,
      message: 'Error generating Response',
    }
  }
}

export const getLabInchargeList = async () => {
  try {
    const response = await startSxpProxy(
      ADMIN_PROJECT_ID,
      intent?.getLabInchargeList
    )
    return {
      response: response?.data,
      success: true,
    }
  } catch (error) {
    return {
      response: null,
      success: false,
      message: 'Error generating Response',
    }
  }
}

export const getPatientsByIds = async (ids: string) => {
  try {
    const response = await startSxpProxy(
      OPD_PROJECT_ID,
      Labintent?.getPatientsByIdsApi,
      {
        ids,
      }
    )
    return {
      response: response?.data,
      success: true,
    }
  } catch (error) {
    return {
      response: null,
      success: false,
      message: 'Error generating Response',
    }
  }
}

export const getLabOrdersByPatientIdAndStatus = async (
  patientId: string[],
  limit: number,
  offset: number,
  active: boolean
) => {
  try {
    const response = await startSxpProxy(
      LABS_PROJECT_ID,
      intentLab?.newLabOrdersByPatientIdAndStatus,
      {
        patientId,
        limit,
        offset,
        active,
      }
    )
    return {
      response: response?.data,
      success: true,
    }
  } catch (error) {
    return {
      response: null,
      success: false,
      message: 'Error generating Response',
    }
  }
}

export const getLabTestsByIds = async (orderId: string, ids: string[]) => {
  try {
    const response = await startSxpProxy(
      LABS_PROJECT_ID,
      intentLab?.getLabTestsByIds,
      {
        orderId,
        ids,
      }
    )
    return {
      response: response?.data,
      success: true,
    }
  } catch (error) {
    return {
      response: null,
      success: false,
      message: 'Error generating Response',
    }
  }
}

export const archivedLabOrders = async (
  patientIds: string[],
  pageSize: number,
  page: number
) => {
  try {
    const response = await startSxpProxy(
      LABS_PROJECT_ID,
      intentLab?.newLabOrdersByPatientIdAndStatus,
      {
        patientId: patientIds,
        limit: pageSize,
        offset: page,
      }
    )
    return {
      response: response?.data,
      success: true,
    }
  } catch (error) {
    return {
      response: null,
      success: false,
      message: 'Error generating Response',
    }
  }
}

export const updatedOrderEventByOrderId = async (state: any) => {
  try {
    const response = await startSxpProxy(
      LABS_PROJECT_ID,
      intentLab?.modifyLabOrderEvent,
      state
    )
    if (response?.data?.success) {
      return {
        response: response?.data?.data || {},
        success: true,
        message: response?.data?.message,
      }
    }
  } catch (error) {
    return {
      response: null,
      success: false,
      message: 'Error while updating Order Event',
    }
  }
}

export const getLabOrdersByVisitId = async (visitId: string) => {
  try {
    const response = await startSxpProxy(
      LABS_PROJECT_ID,
      OPD_ORDERS_CONSTANTS.INTENT_GET_LAB_ORDERS,
      { visitId }
    )
    return {
      data: response?.data?.lab_orders ?? [],
      success: true,
      message: 'Fetched lab orders successfully',
    }
  } catch (error) {
    return {
      data: [],
      success: false,
      message: 'Error fetching lab orders',
    }
  }
}

export const getVisitByEncounterId = async (encounterId: string) => {
  try {
    const response = await startSxpProxy(
      OPD_PROJECT_ID,
      OPD_ORDERS_CONSTANTS.INTENT_GET_VISIT,
      { encounterId }
    )
    return {
      data: response?.data,
      success: true,
      message: 'Fetched visit successfully',
    }
  } catch (error) {
    return {
      data: null,
      success: false,
      message: 'Error fetching visit',
    }
  }
}

export const getRadiologyOrdersByVisitId = async (visitId: string) => {
  try {
    const response = await startSxpProxy(
      RADIOLOGY_PROJECT_ID,
      'getRadiologyOrdersByVisitId',
      { visitId }
    )
    return {
      data: response?.data?.radiology_orders ?? [],
      success: true,
      message: 'Fetched radiology orders successfully',
    }
  } catch (error) {
    return {
      data: [],
      success: false,
      message: 'Error fetching radiology orders',
    }
  }
}

export const getRadiologyOrdersForPatientForOpd = async (
  patientId: string,
  source: string
) => {
  try {
    const response = await axiosClient.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${RADIOLOGY_ORDERS_OPD_LOCATION}?patientId=${patientId}&source=${source}`
    )
    return {
      data: response?.data?.radiology_orders ?? [],
      success: true,
      message: 'Fetched radiology orders for patient successfully',
    }
  } catch (error) {
    return {
      data: [],
      success: false,
      message: 'Error fetching radiology orders for patient',
    }
  }
}
export const getClusterAndType = async () => {
  try {
    const intent = getClusterandType

    const response = await startSxpProxy(ADMIN_PROJECT_ID, intent)

    return {
      data: response?.data?.data?.clusters || response?.data?.clusters || [],
      success: true,
      message: { successcluster },
    }
  } catch (error) {
    return {
      data: [],
      success: false,
      message: { errorcluster },
    }
  }
}
